import UnifiedSearchResultGridItem from '@klaviyo-mkt/gatsby-components/molecules/unified-search-result-grid-item';

import { useGetUserCourseData } from '@academy/skilljar/userData/useGetUserCourseData';
import { sortCourseParts } from '@academy/utils/collection';

import * as s from '@academy/components/shared/styles/templates/template.module.scss';

import type { ICollection } from '@academy/graphql/types';
import type { ICourseProgress, IUserCourseData } from '@academy/skilljar/types';

interface ICollectionCourses {
  collection: ICollection;
  userCourseData?: ICourseProgress;
}

export const CollectionCourses = ({ collection, userCourseData }: ICollectionCourses) => {
  const coursesList = [...collection?.courses];
  return (
    <div className={s.collectionCourses}>
      {sortCourseParts(coursesList).map((course) => (
        <UnifiedSearchResultGridItem
          courseId={course.thirdPartyId}
          description={course.previewText || ''}
          duration={course.estimatedCompletionTimeMinutes ? `${course.estimatedCompletionTimeMinutes}` : null}
          divider={!!course.estimatedCompletionTimeMinutes}
          key={course.thirdPartyId}
          link={`/en-us/collections/${collection?.slug}/${course.slug}`}
          pill="Course"
          title={course.title}
          truncateText={false}
          userCourseData={userCourseData}
        />
      ))}
    </div>
  );
};

type TCollectionCourses = Omit<ICollectionCourses, 'userData'>;

export const CollectionCoursesWithData = ({ ...props }: TCollectionCourses) => {
  const userCourseData: IUserCourseData = useGetUserCourseData();

  return (
    <CollectionCourses
      userCourseData={userCourseData}
      {...props}
    />
  );
};
